import { lazy, Suspense } from 'react';
import style from './AppStoreLink-style.scss';

const AppStoreLinkReactLazy = lazy(() =>
    import(/* webpackChunkName: "AppStoreLink" */ './AppStoreLink')
);

const AppStoreLinkPlaceholder = () => <div className={style.placeholder} />;

const AppStoreLinkLazy = () => {
    return (
        <Suspense fallback={<AppStoreLinkPlaceholder />}>
            <AppStoreLinkReactLazy />
        </Suspense>
    );
};

export default AppStoreLinkLazy;
